import { render, staticRenderFns } from "./Ajuda.vue?vue&type=template&id=70e49f0c&scoped=true"
import script from "./Ajuda.vue?vue&type=script&lang=js"
export * from "./Ajuda.vue?vue&type=script&lang=js"
import style0 from "./Ajuda.vue?vue&type=style&index=0&id=70e49f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e49f0c",
  null
  
)

export default component.exports